import styled from '@emotion/styled';

export default styled.div({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem'
});
